import React from 'react';
import {
  Drawer,
  Box,
  Typography,
  Divider,
  List,
  Button
} from '@mui/material';
import { CartItem } from './CartItem';
import { useCart } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Cart = ({ open, onClose }) => {
  const { cart, getTotalPrice } = useCart();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleCheckout = () => {
    onClose();
    navigate('/checkout');
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 350, p: 2 }}>
        <Typography variant="h5" gutterBottom>
          {t('cart.title')}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        
        {cart.length === 0 ? (
          <Typography variant="body1" color="text.secondary">
            {t('cart.empty')}
          </Typography>
        ) : (
          <>
            <List>
              {cart.map(item => (
                <CartItem key={item.id} item={item} />
              ))}
            </List>
            
            <Divider sx={{ my: 2 }} />
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="h6">{t('cart.total')}:</Typography>
              <Typography variant="h6" color="primary">
                €{getTotalPrice()}
              </Typography>
            </Box>
            
            <Button 
              variant="contained" 
              fullWidth 
              size="large"
              onClick={handleCheckout}
            >
              {t('cart.checkout')}
            </Button>
          </>
        )}
      </Box>
    </Drawer>
  );
};